export default "__VITE_ASSET__DRVnCohM__"